import { useSettingsStore } from "./settingsStore";

export const SOFT_LAUNCH_KEY = "kaynin_soft_launch_enabled";

export const isSoftLaunchEnabled = (): boolean => {
  return useSettingsStore.getState().getSetting(SOFT_LAUNCH_KEY, false) as boolean;
};

export const setSoftLaunchEnabled = (enabled: boolean): void => {
  useSettingsStore.getState().updateSetting(SOFT_LAUNCH_KEY, enabled);
};
